//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.type

import com.apollographql.apollo.api.CustomScalarType

/**
 * The `String` scalar type represents textual data, represented as UTF-8
 * character sequences. The String type is most often used by GraphQL to
 * represent free-form human-readable text.
 */
public class GraphQLString {
  public companion object {
    public val type: CustomScalarType = CustomScalarType("String", "kotlin.String")
  }
}
